export enum SiteFooterType {
  Mobile,
  None,
}
